import { CityType } from 'features/Address/types';
import { ClsItem, ObjIdentifier } from 'types/clsType';
import { SettingsModelType } from 'types/settingsType';
import { UserType } from 'types/stateTypes';
import {
  AcademicDegree,
  Author,
  ContactData,
  Education,
  EducationBase,
  LaborActivity,
  LaborActivityPayload,
  Organization,
  ScientificInterest,
  UploadItemFilter,
} from 'types/uploadType';
import { ActionType, PayloadErrorType } from '../../types/reduxTypes';
import {
  CREATE_ADDRESS,
  DELETE_ADDRESS,
  DELETE_EDUCATION,
  DELETE_EDUCATION_FAILED,
  DELETE_EDUCATION_SUCCESS,
  DELETE_LABOR_ACIVITY,
  DELETE_LABOR_ACIVITY_FAILED,
  DELETE_LABOR_ACIVITY_SUCCESS,
  EDIT_ADDRESS,
  EDIT_DEGREES,
  EDIT_DEGREES_FAILED,
  EDIT_DEGREES_SUCCESS,
  EDIT_EDUCATION,
  EDIT_EDUCATION_FAILED,
  EDIT_EDUCATION_SUCCESS,
  EDIT_LABOR_ACIVITY,
  EDIT_LABOR_ACIVITY_FAILED,
  EDIT_LABOR_ACIVITY_SUCCESS,
  FIND_CITIES,
  FIND_CITIES_FAILED,
  FIND_CITIES_SUCCESS,
  GET_ACTIVITY_AREAS,
  GET_ACTIVITY_AREAS_FAILED,
  GET_ACTIVITY_AREAS_SUCCESS,
  GET_CONTACTS,
  GET_CONTACTS_FAILED,
  GET_CONTACTS_SUCCESS,
  GET_COUNTRIES,
  GET_COUNTRIES_FAILED,
  GET_COUNTRIES_SUCCESS,
  GET_DEGREES,
  GET_DEGREES_FAILED,
  GET_DEGREES_SUCCESS,
  GET_EDUCATION,
  GET_EDUCATION_FAILED,
  GET_EDUCATION_SUCCESS,
  GET_EDUCATION_TYPES,
  GET_EDUCATION_TYPES_FAILED,
  GET_EDUCATION_TYPES_SUCCESS,
  GET_LABOR_ACIVITY,
  GET_LABOR_ACIVITY_FAILED,
  GET_LABOR_ACIVITY_SUCCESS,
  GET_POSITIONS,
  GET_POSITIONS_FAILED,
  GET_POSITIONS_SUCCESS,
  GET_SCIENTIFIC_INTERESTS,
  GET_SCIENTIFIC_INTERESTS_FAILED,
  GET_SCIENTIFIC_INTERESTS_SUCCESS,
  GET_SETTINGS_MODEL,
  GET_SETTINGS_MODEL_FAILED,
  GET_SETTINGS_MODEL_SUCCESS,
  GET_USER_AUTHORS,
  GET_USER_AUTHORS_FAILED,
  GET_USER_AUTHORS_SUCCESS,
  POST_CONTACTS,
  POST_CONTACTS_FAILED,
  POST_CONTACTS_SUCCESS,
  POST_DEGREES,
  POST_DEGREES_FAILED,
  POST_DEGREES_SUCCESS,
  POST_EDUCATION,
  POST_EDUCATION_FAILED,
  POST_EDUCATION_SUCCESS,
  POST_LABOR_ACIVITY,
  POST_LABOR_ACIVITY_FAILED,
  POST_LABOR_ACIVITY_SUCCESS,
  POST_OBJ_IDENTIFIERS,
  POST_OBJ_IDENTIFIERS_FAILED,
  POST_OBJ_IDENTIFIERS_SUCCESS,
  POST_SCIENTIFIC_INTERESTS,
  POST_SCIENTIFIC_INTERESTS_FAILED,
  POST_SCIENTIFIC_INTERESTS_SUCCESS,
  SEARCH_ORGANIZATION,
  SEARCH_ORGANIZATION_FAILED,
  SEARCH_ORGANIZATION_SUCCESS,
} from '../constants';

export interface GetUserProfileDataPayload {
  userId: string;
}

export interface PostLaborActivityPayload {
  userId: string;
  items: LaborActivityPayload[];
}

type AddressType = {
  id: string;
  sd: string;
  ed: string;
  cType: ClsItem;
  postalcode: number;
  ctFias: string;
  room: string;
  notStucturedAddress: string;
  dsc: string;
  cIsVerified: string;
  rObject: string;
  cCountry: ClsItem;
  cCity: CityType;
  city: string;
};

export type CreateAddressType = Partial<Omit<AddressType, 'cType' | 'rObject'>> &
  Pick<AddressType, 'cType' | 'rObject'>;
export type EditAddressType = Partial<Omit<AddressType, 'id' | 'cType' | 'rObject'>> &
  Pick<AddressType, 'id' | 'cType' | 'rObject'>;

export interface PostEducationPayload {
  userId: string;
  items: EducationBase[];
}

export interface EditEducationPayload {
  userId: string;
  items: Education[];
}

export interface PostContactsPayload {
  userId: string;
  contactsToCommit: ContactData[];
  contactsToRemove: ContactData[];
}

export interface PostScientificInterestsPayload {
  userId: string;
  interestsToCommit: ScientificInterest[];
}

export interface PostObjIdentifiersPayload {
  user: UserType;
  identifiersToCommit: ObjIdentifier[];
}

export interface DeleteItemPayload {
  userId: string;
  itemId: string;
}

export type GetClsItemsPayload = {
  lang: number;
};

export type FindCitiesPayload = GetClsItemsPayload & {
  term: string;
};

export type FindCitiesByCountryPayload = FindCitiesPayload & {
  country: ClsItem;
};

export type SwitchUploadListFilterPayload = GetClsItemsPayload & {
  filters: UploadItemFilter[];
};

export function searchOrganization(payload: string): ActionType<string> {
  return {
    payload,
    type: SEARCH_ORGANIZATION,
  };
}
export function searchOrganizationFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: SEARCH_ORGANIZATION_FAILED,
  };
}
export function searchOrganizationSuccess(payload: Organization[]): ActionType<Organization[]> {
  return {
    payload,
    type: SEARCH_ORGANIZATION_SUCCESS,
  };
}

export function getPositions(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_POSITIONS,
  };
}

export function getPositionsFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_POSITIONS_FAILED,
  };
}

export function getPositionsSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_POSITIONS_SUCCESS,
  };
}

export function getLaborActivity(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_LABOR_ACIVITY,
  };
}

export function getLaborActivityFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_LABOR_ACIVITY_FAILED,
  };
}

export function getLaborActivitySuccess(payload: LaborActivity[]): ActionType<LaborActivity[]> {
  return {
    payload,
    type: GET_LABOR_ACIVITY_SUCCESS,
  };
}

export function getDegrees(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_DEGREES,
  };
}

export function getDegreesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_DEGREES_FAILED,
  };
}

export function getDegreesSuccess(payload: AcademicDegree[]): ActionType<AcademicDegree[]> {
  return {
    payload,
    type: GET_DEGREES_SUCCESS,
  };
}

export function postDegrees(payload: AcademicDegree[]): ActionType<AcademicDegree[]> {
  return {
    payload,
    type: POST_DEGREES,
  };
}

export function postDegreesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: POST_DEGREES_FAILED,
  };
}

export function postDegreesSuccess(payload: AcademicDegree[]): ActionType<AcademicDegree[]> {
  return {
    payload,
    type: POST_DEGREES_SUCCESS,
  };
}

export function editDegrees(payload: AcademicDegree[]): ActionType<AcademicDegree[]> {
  return {
    payload,
    type: EDIT_DEGREES,
  };
}

export function editDegreesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: EDIT_DEGREES_FAILED,
  };
}

export function editDegreesSuccess(payload: AcademicDegree[]): ActionType<AcademicDegree[]> {
  return {
    payload,
    type: EDIT_DEGREES_SUCCESS,
  };
}

export function postLaborActivity(payload: PostLaborActivityPayload): ActionType<PostLaborActivityPayload> {
  return {
    payload,
    type: POST_LABOR_ACIVITY,
  };
}

export function postLaborActivityFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: POST_LABOR_ACIVITY_FAILED,
  };
}

export function postLaborActivitySuccess(payload: string[]): ActionType<string[]> {
  return {
    payload,
    type: POST_LABOR_ACIVITY_SUCCESS,
  };
}

export function editLaborActivity(payload: PostLaborActivityPayload): ActionType<PostLaborActivityPayload> {
  return {
    payload,
    type: EDIT_LABOR_ACIVITY,
  };
}

export function editLaborActivitySuccess(payload: string): ActionType<string> {
  return {
    payload,
    type: EDIT_LABOR_ACIVITY_SUCCESS,
  };
}

export function editLaborActivityFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: EDIT_LABOR_ACIVITY_FAILED,
  };
}

export function deleteLaborActivity(payload: DeleteItemPayload): ActionType<DeleteItemPayload> {
  return {
    payload,
    type: DELETE_LABOR_ACIVITY,
  };
}

export function deleteLaborActivityFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: DELETE_LABOR_ACIVITY_FAILED,
  };
}

export function deleteLaborActivitySuccess(payload: string[]): ActionType<string[]> {
  return {
    payload,
    type: DELETE_LABOR_ACIVITY_SUCCESS,
  };
}

export function deleteEducation(payload: DeleteItemPayload): ActionType<DeleteItemPayload> {
  return {
    payload,
    type: DELETE_EDUCATION,
  };
}

export function deleteEducationFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: DELETE_EDUCATION_FAILED,
  };
}

export function deleteEducationSuccess(payload: string[]): ActionType<string[]> {
  return {
    payload,
    type: DELETE_EDUCATION_SUCCESS,
  };
}

export function getActivityAreas(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_ACTIVITY_AREAS,
  };
}

export function getActivityAreasFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_ACTIVITY_AREAS_FAILED,
  };
}

export function getActivityAreasSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_ACTIVITY_AREAS_SUCCESS,
  };
}

export function getEducationTypes(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_EDUCATION_TYPES,
  };
}

export function getEducationTypesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_EDUCATION_TYPES_FAILED,
  };
}

export function getEducationTypesSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_EDUCATION_TYPES_SUCCESS,
  };
}

export function getCountries(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_COUNTRIES,
  };
}

export function getCountriesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_COUNTRIES_FAILED,
  };
}

export function getCountriesSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_COUNTRIES_SUCCESS,
  };
}

export function findCities(payload: FindCitiesPayload): ActionType<FindCitiesPayload> {
  return {
    payload,
    type: FIND_CITIES,
  };
}

export function findCitiesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: FIND_CITIES_FAILED,
  };
}

export function findCitiesSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: FIND_CITIES_SUCCESS,
  };
}

export function postEducation(payload: PostEducationPayload): ActionType<PostEducationPayload> {
  return {
    payload,
    type: POST_EDUCATION,
  };
}

export function postEducationFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: POST_EDUCATION_FAILED,
  };
}

export function postEducationSuccess(payload: string[]): ActionType<string[]> {
  return {
    payload,
    type: POST_EDUCATION_SUCCESS,
  };
}

export function editEducation(payload: EditEducationPayload): ActionType<PostEducationPayload> {
  return {
    payload,
    type: EDIT_EDUCATION,
  };
}

export function editEducationFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: EDIT_EDUCATION_FAILED,
  };
}

export function editEducationSuccess(payload: string[]): ActionType<string[]> {
  return {
    payload,
    type: EDIT_EDUCATION_SUCCESS,
  };
}

export function getEducation(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_EDUCATION,
  };
}

export function getEducationFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_EDUCATION_FAILED,
  };
}

export function getEducationSuccess(payload: LaborActivity[]): ActionType<LaborActivity[]> {
  return {
    payload,
    type: GET_EDUCATION_SUCCESS,
  };
}

export function getContacts(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_CONTACTS,
  };
}

export function getContactsFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_CONTACTS_FAILED,
  };
}

export function getContactsSuccess(payload: ContactData[]): ActionType<ContactData[]> {
  return {
    payload,
    type: GET_CONTACTS_SUCCESS,
  };
}

export function postContacts(payload: PostContactsPayload): ActionType<PostContactsPayload> {
  return {
    payload,
    type: POST_CONTACTS,
  };
}

export function postContactsFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: POST_CONTACTS_FAILED,
  };
}

export function postContactsSuccess(payload: string[]): ActionType<string[]> {
  return {
    payload,
    type: POST_CONTACTS_SUCCESS,
  };
}

export function getScientificInterests(payload: string): ActionType<string> {
  return {
    payload,
    type: GET_SCIENTIFIC_INTERESTS,
  };
}

export function getScientificInterestsFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_SCIENTIFIC_INTERESTS_FAILED,
  };
}

export function getScientificInterestsSuccess(payload: ScientificInterest[]): ActionType<ScientificInterest[]> {
  return {
    payload,
    type: GET_SCIENTIFIC_INTERESTS_SUCCESS,
  };
}

export function postScientificInterests(
  payload: PostScientificInterestsPayload
): ActionType<PostScientificInterestsPayload> {
  return {
    payload,
    type: POST_SCIENTIFIC_INTERESTS,
  };
}

export function postScientificInterestsFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: POST_SCIENTIFIC_INTERESTS_FAILED,
  };
}

export function postScientificInterestsSuccess(payload: string[]): ActionType<string[]> {
  return {
    payload,
    type: POST_SCIENTIFIC_INTERESTS_SUCCESS,
  };
}

export function postObjIdentifiers(payload: PostObjIdentifiersPayload): ActionType<PostObjIdentifiersPayload> {
  return {
    payload,
    type: POST_OBJ_IDENTIFIERS,
  };
}

export function postObjIdentifiersFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: POST_OBJ_IDENTIFIERS_FAILED,
  };
}

export function postObjIdentifiersSuccess(payload: string[]): ActionType<string[]> {
  return {
    payload,
    type: POST_OBJ_IDENTIFIERS_SUCCESS,
  };
}

export function getUserAuthors(payload: GetUserProfileDataPayload): ActionType<GetUserProfileDataPayload> {
  return {
    payload,
    type: GET_USER_AUTHORS,
  };
}

export function getUserAuthorsFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_USER_AUTHORS_FAILED,
  };
}

export function getUserAuthorsSuccess(payload: Author[]): ActionType<Author[]> {
  return {
    payload,
    type: GET_USER_AUTHORS_SUCCESS,
  };
}

export function getSettingsModel(payload: unknown): ActionType {
  return {
    payload,
    type: GET_SETTINGS_MODEL,
  };
}

export function getSettingsModelSuccess(payload: SettingsModelType): ActionType {
  return {
    payload,
    type: GET_SETTINGS_MODEL_SUCCESS,
  };
}

export function getSettingsModelFailed(payload: PayloadErrorType): ActionType {
  return {
    payload,
    type: GET_SETTINGS_MODEL_FAILED,
  };
}

export function createAddress(payload: CreateAddressType): ActionType<CreateAddressType> {
  return {
    payload,
    type: CREATE_ADDRESS,
  };
}

export function editAddress(payload: EditAddressType): ActionType<EditAddressType> {
  return {
    payload,
    type: EDIT_ADDRESS,
  };
}

export function deleteAddress(payload: string): ActionType<string> {
  return {
    payload,
    type: DELETE_ADDRESS,
  };
}
